import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { PdfShareLinkState } from './types';

export const getInitialPdfShareLinkState = (): PdfShareLinkState => ({
    shortUrl: undefined,
    cachedForVersion: undefined,
    requestStatus: ApiRequestStatus.Idle
});
